import { useEffect } from "react";

export function useDeepEffect(callback, dependencies) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(callback, dependencies.map(JSON.stringify))
}
